export default __webpack_public_path__ + "static/express-6c2252518a047b6040d1c2f662cfc699.png";